<template>
  <section class="elect-mayor" v-if="data">
    <ElectLabel :year="year" :category="category" :color="themeColor" /><!--
  --><div class="elect-mayor__section">
      <SegmentChart
        :caption="segmentChartCaption"
        :winner-color="themeColor"
        :colors="segmentChartColors"
        :values="segmentChartValues"
        :labels="segmentChartLabels"
        :roles="segmentChartRoles"/>
      <SummaryTable
        :data="SummaryTableData"
        :head-color="themeColor"/>
    </div><!--
  --><div class="elect-mayor__section">
      <MapChart
        :year="Number(year)"
        :ids="mapChartIds"
        :names="mapChartNames"
        :colors="mapChartColors"
        :detail="mapChartDetail"
        :head-color="themeColor"/>
    </div><!--
  --><div class="elect-mayor__section">
      <DonutChart
        v-if="data.notVoting.all"
        :theme-color="themeColor"
        :display="donutChartDisplay"
        :comparison="donutChartComparison"
        :values="donutChartValues"
        :colors="['#c6c6c6', themeColor]"
        :labels="['投票數', '未投票']"/>
      <NotVotingTable
        v-if="data.notVoting.counties && data.notVoting.counties.length"
        :color="themeColor"
        :data="notVotingTableData"/>
    </div>
  </section>
</template>

<script>
import { PARTY_COLORS, PARTY_NAMES, COUNTY_NAMES_CH2EN_MAPPING } from '@/constant'
import ElectLabel from '@/components/ElectLabel'
import SegmentChart from '@/components/SegmentChart'
import SummaryTable from '@/components/SummaryTable'
import MapChart from '@/components/MapChart'
import DonutChart from '@/components/DonutChart'
import NotVotingTable from '@/components/NotVotingTable'

export default {
  name: 'ElectMayor',
  components: {
    ElectLabel,
    SegmentChart,
    SummaryTable,
    MapChart,
    DonutChart,
    NotVotingTable
  },
  props: {
    data: { type: Object, default: () => {} }
  },
  data () {
    return {
      category: '地方首長',
      themeColor: '#c7bff3',
      selectedCountyId: ''
    }
  },
  computed: {
    year () {
      return this.data.year.toString()
    },
    segmentChartCaption () {
      return '執政縣市'
    },
    segmentChartColors () {
      return this.data.result.map(({ party }) => PARTY_COLORS[party])
    },
    segmentChartValues () {
      return this.data.result.map(({ proportion }) => proportion)
    },
    segmentChartLabels () {
      return this.data.result.map(({ seats }) => `${seats} 席`)
    },
    segmentChartRoles () {
      return this.data.result.map(({ party }) => [ PARTY_NAMES[party] ])
    },
    SummaryTableData () {
      return this.data.result.map(({ party, votes, proportion, offsetProportion, offsetVotes }) => {
        return { party, votes, proportion, offsetProportion, offsetVotes }
      })
    },
    mapChartNames () {
      const names = Object.keys(this.data.detail)
      if (Number(this.year) !== 2010) {
        return [ ...names ]
      }
      // [trick] taoyuan upgraded to municipality in 2014, make data in year 2010 and above be compatible
      return [ ...names.map(name => (name === '桃園縣' ? '桃園市' : name)) ]
    },
    mapChartIds () {
      return this.mapChartNames.map(name => COUNTY_NAMES_CH2EN_MAPPING[name])
    },
    mapChartColors () {
      return this.mapChartNames.map((name) => {
        // [trick] taoyuan upgraded to municipality in 2014, make data in year 2010 and above be compatible
        if (Number(this.year) === 2010 && name === '桃園市') {
          name = '桃園縣'
        }
        const mayor = this.data.detail[name].filter(candidate => candidate.isElected)[0] || null
        return !mayor ? null : PARTY_COLORS[mayor.party]
      })
    },
    mapChartDetail () {
      let detail = { ...this.data.detail }
      // [trick] taoyuan upgraded to municipality in 2014, make data in year 2010 and above be compatible
      if (Number(this.year) === 2010) {
        detail['桃園市'] = JSON.parse(JSON.stringify(detail['桃園縣']))
        delete detail['桃園縣']
      }
      detail = this.mapChartNames.reduce((obj, name, index) => {
        const countyId = this.mapChartIds[index]
        // console.log(name, countyId, detail[name])
        obj[countyId] = detail[name]
        return obj
      }, {})
      return { ...detail }
    },
    donutChartDisplay () {
      return this.data.notVoting.all.notVotes
    },
    donutChartComparison () {
      return this.data.notVoting.all.offsetProportion
    },
    donutChartValues () {
      const { proportion, notProportion } = this.data.notVoting.all
      return [ proportion, notProportion ]
    },
    notVotingTableData () {
      return this.data.notVoting.counties.map(({ county, notVotes, notProportion }) => ({ county, notVotes, notProportion }))
    }
  }
}
</script>

<style lang="scss">
.elect-mayor {
  position: relative;
  @include rwd($RWD_DESKTOP_WIDE) {
  }

  .elect-label {
    @include rwd($RWD_DESKTOP_WIDE) {
      left: -30px;
    }
  }

  &__section {
    @include rwd($RWD_DESKTOP_WIDE) {
      // float: left;
      display: inline-block;
      position: relative;
      width: 50%;
      vertical-align: top;
    }
    &:nth-of-type(2n) {
      @include rwd($RWD_DESKTOP_WIDE) {
        left: -60px;
      }
    }

    &:nth-of-type(3) {
      @include rwd($RWD_DESKTOP_WIDE) {
        float: right;
        .map-chart {
          margin-top: 24px;
        }
      }
    }
  }
}
</style>
